export default __webpack_public_path__ + "static/media/avatar-s-25.301316d5.jpg";